import './swipe';
import './longpress';
import './ui/debug';

import {UI} from './ui/ui';

// eslint-disable-next-line @typescript-eslint/no-floating-promises
UI.create();
